export default [
  {
    device_id: '9fa747a2-25ff-48ee-b078-04381f7c828f',
    name: 'Checkout - Successful',
    code: 'PaymentSuccess',
    product_type: 'TERMINAL_API',
    status: 'PAIRED',
    location_id: 'L5TPWFJBPJPWV',
    pair_by: '2025-12-31T23:59:59Z',
    created_at: '2025-06-05T10:00:00Z',
    status_changed_at: '2025-06-05T10:30:00Z',
    id: 'test_device_001'
  },
  {
    device_id: '0a956d49-619a-4530-8e5e-8eac603ffc5e',
    name: 'Checkout - Failure(timeout)',
    code: 'PaymentFailure',
    product_type: 'TERMINAL_API',
    status: 'PAIRED',
    location_id: 'L5TPWFJBPJPWV',
    pair_by: '2025-12-31T23:59:59Z',
    created_at: '2025-06-05T11:00:00Z',
    status_changed_at: '2025-06-05T11:30:00Z',
    id: 'test_device_002'
  },
  {
    device_id: 'da40d603-c2ea-4a65-8cfd-f42e36dab0c7',
    name: 'Checkout - Allow Cancel',
    code: 'CancelAllowed',
    product_type: 'TERMINAL_API',
    status: 'PAIRED',
    location_id: 'L5TPWFJBPJPWV',
    pair_by: '2025-12-31T23:59:59Z',
    created_at: '2025-06-05T12:00:00Z',
    status_changed_at: '2025-06-05T12:00:00Z',
    id: 'test_device_003'
  },
  {
    device_id: 'da40d603-c2ea-4a65-8cfd-f42e36dab0c8',
    name: 'Checkout - Unpaired Terminal',
    code: 'UnpairedTerminal',
    product_type: 'TERMINAL_API',
    status: 'UNPAIRED',
    location_id: 'L5TPWFJBPJPWV',
    pair_by: '2025-12-31T23:59:59Z',
    created_at: '2025-06-05T12:00:00Z',
    status_changed_at: '2025-06-05T12:00:00Z',
    id: 'test_device_003'
  }
]
